"use client";
import React from "react";

import Typography from "@mui/material/Typography";
import clsx from "clsx";

import { StoreDepartment as StoreDepartmentProps } from "~/bff/types/StoreDepartment";
import { CombinedLink } from "~/components/combined-link/component";
import { Image } from "~/components/image/component";
import { processYextImage } from "~/components/store-details-page/helpers";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { imageTemplates, STORE_DEPARTMENT_WITH_IMAGE_CLASSES } from "./constants";
import { StoreDepartmentWithImageContainer } from "./styled";

export const StoreDepartmentWithImage: React.FC<
  StoreDepartmentProps & { isStoreSelector?: boolean }
> = ({
  departmentName,
  departmentFloor,
  departmentURL,
  departmentImage,
  fontColour,
  isStoreSelector = false,
}) => {
  const { isAmplienceImage, imageSrc } = processYextImage(departmentImage);
  const linkAriaLabel = !departmentFloor
    ? departmentName
    : `${departmentName} ${departmentFloor}`;

  return (
    <StoreDepartmentWithImageContainer
      textColor={fontColour?.toLowerCase()}
      departmentURL={!!departmentURL}
      isStoreSelector={isStoreSelector}
    >
      <CombinedLink
        {...(departmentURL && { href: departmentURL })}
        className={STORE_DEPARTMENT_WITH_IMAGE_CLASSES.root}
        {...getTestAutomationProps("department")}
        aria-label={linkAriaLabel ?? ""}
      >
        <Image
          className={STORE_DEPARTMENT_WITH_IMAGE_CLASSES.image}
          alt={departmentImage?.alternateText ?? ""}
          src={imageSrc ?? ""}
          imageTemplates={isAmplienceImage ? imageTemplates : undefined}
        />
        <Typography
          className={clsx(
            STORE_DEPARTMENT_WITH_IMAGE_CLASSES.text,
            STORE_DEPARTMENT_WITH_IMAGE_CLASSES.name,
          )}
        >
          {departmentName}
        </Typography>
        <Typography
          className={clsx(
            STORE_DEPARTMENT_WITH_IMAGE_CLASSES.text,
            STORE_DEPARTMENT_WITH_IMAGE_CLASSES.floor,
          )}
        >
          {departmentFloor ?? <br />}
        </Typography>
      </CombinedLink>
    </StoreDepartmentWithImageContainer>
  );
};
